import { Link } from "react-router-dom";

const cardClass =
  "rounded-xl border border-slate-800/80 bg-slate-900/40 px-5 py-5 text-left";

export const WhySection = () => {
  return (
    <section className={`${cardClass} flex h-full min-h-0 flex-col`}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
        Why this exists
      </p>
      <p className="mt-2 text-sm font-medium text-slate-100">
        The networking event I kept wishing existed.
      </p>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">
        Too many rooms where the networking is weak. I wanted high signal
        instead — founders who walk out with solutions and real momentum on
        their business.
      </p>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">
        Before you show up, I look at every profile specifically for{" "}
        <span className="font-semibold text-slate-100">
          how I can help your business
        </span>{" "}
        —{" "}
        <span className="font-semibold text-slate-100">
          who I can connect you with
        </span>{" "}
        or{" "}
        <span className="font-semibold text-slate-100">
          who in my network can help
        </span>
        .
      </p>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">
        Think of me as a super-connector in training. This event is my gym.
      </p>
      <Link
        to="/how-it-works"
        className="mt-auto inline-flex pt-4 text-sm text-emerald-400 transition hover:text-emerald-300"
      >
        How this works →
      </Link>
    </section>
  );
};
